import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { advancedFlowSchema_ } from "./advanced-flow-db-parser";

const resultSchema = z.object({
  emailsSent: z.array(z.object({ templateId: z.string() })),
  smsSent: z.array(z.object({ templateId: z.string() })),
  runtimeException: z.string().optional(),
});

const yieldedResultSchema = z.object({
  result: resultSchema,
  yieldedValue: z.any().optional(),
  nextStepId: z.string().nullish(),
  sleepingUntil: z.date().optional(),
});

const stateHistoryEntrySchema = z.object({
  runStartedAt: z.date(),
  runFinishedAt: z.date(),
  stepId: z.string(),
  refreshedSchemaInstance: z.any(),
  yieldedResult: yieldedResultSchema,
  depth: z.number(),
  stateHistoryResult: z.any().optional(),
});

const automationExecutionSchema_ = z.object({
  _id: zExt.objectId(),
  flow: advancedFlowSchema_,
  teamId: zExt.objectId(),
  runId: z.string(),
  workflowId: z.string(),
  schemaInstance: z.any(),
  skipSending: z.boolean().optional(),
  stateHistory: z.array(stateHistoryEntrySchema).default([]),
  latestState: stateHistoryEntrySchema.optional(),
  terminated: z.boolean().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const automationExecutionSchema: z.ZodType<AutomationExecution> =
  automationExecutionSchema_;
export interface AutomationExecution extends z.infer<
  typeof automationExecutionSchema_
> {}

export interface StateHistoryEntry extends z.infer<
  typeof stateHistoryEntrySchema
> {}
export interface YieldedResult extends z.infer<typeof yieldedResultSchema> {}
export interface Result extends z.infer<typeof resultSchema> {}
